/* eslint-disable */
(function ($) {
	$(document).ready(() => {
		const htmlItem = $("html");
		const navButton = $("#toggle");
		const toggleWidth = 1310;
		const disabled = $(".disabled");

		navButton.on("click", function () {
			if ($(window).width() < toggleWidth) {
				htmlItem.toggleClass("open");
			}
		});

		disabled.children("a").attr("href", "javascript:void(0)");

		$(window).on("resize", function () {
			if ($(window).width() >= toggleWidth) {
				htmlItem.removeClass("open");
			}
		});

		var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
		/* your code here */
		$(".dropdown").hover(
			function() {
				if (!isMobile && jQuery(window).width() > toggleWidth) {
					$(this).find(".dropdown-menu").addClass("focus");
				}
			},
			function() {
				if (!isMobile && jQuery(window).width() > toggleWidth) {
					$(".dropdown-menu").removeClass("focus");
				}
			}
		);

		// if($("body").find(".pdc_active")) {
			$(".dropdown").click(function(){
				if (isMobile || jQuery(window).width() < toggleWidth) {
					if(!$(this).hasClass('after_menu_has_children')) { //close all others
						$('#footer-menu .dropdown-menu').removeClass('focus');
						$('.menu-item').removeClass('after_menu_has_children');
					}
					$(this).find(".dropdown-menu").toggleClass("focus");
					$(this).toggleClass('after_menu_has_children');
				}
			});
		// }
	});
})(jQuery);

/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/modules/nav.js